module.exports = __webpack_public_path__ + "img/jornaypm_adhd_pediatric_band.9f11c751.svg";